import { useQuery } from "react-query";
import axiosClient from "./../config/axiosClient";

const useSectorsList = () => {
  return useQuery(
    ["static", "sector-list"],
    () => {
      return axiosClient
        .get("/sectors")
    }, {
      initialData: [],
    }
  );  
}

const useBusinessModelsList = () => {
  return useQuery(
    ['business-models-list'],
    () => {
      return axiosClient
        .get('/business_models')
    }, {
      initialData: [],
    }
  );  
}

export {
  useSectorsList,
  useBusinessModelsList,
}
